/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { GetExportConfigurationsQueryResponse } from "../types/GetExportConfigurations.ts"

export const getExportConfigurationsQueryKey = () =>
  [{ url: "/v1/export/get-export-configurations" }] as const

export type GetExportConfigurationsQueryKey = ReturnType<
  typeof getExportConfigurationsQueryKey
>

/**
 * @summary Get export configurations
 * {@link /v1/export/get-export-configurations}
 */
export async function getExportConfigurations(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetExportConfigurationsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/export/get-export-configurations`,
    ...requestConfig,
  })
  return res
}

export function getExportConfigurationsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getExportConfigurationsQueryKey()
  return queryOptions<
    ResponseConfig<GetExportConfigurationsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetExportConfigurationsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getExportConfigurations(config)
    },
  })
}

/**
 * @summary Get export configurations
 * {@link /v1/export/get-export-configurations}
 */
export function useGetExportConfigurations<
  TData = ResponseConfig<GetExportConfigurationsQueryResponse>,
  TQueryData = ResponseConfig<GetExportConfigurationsQueryResponse>,
  TQueryKey extends QueryKey = GetExportConfigurationsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetExportConfigurationsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getExportConfigurationsQueryKey()

  const query = useQuery(
    {
      ...getExportConfigurationsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
